import { deprecatedColors } from 'foundations-theming-base/deprecated-colors';
import { Theme } from '../types';
import { safeLocalStorageGet } from './safeLocalStorage';
import { getCssVariablesTheme, getUseCssVariables } from './localCssVariables';

export const FLASH_TOKENS_STORAGE_KEY = 'trellis:flash-unsafe-tokens';
export const FLASH_CSS_VAR = '--trellis-flash-token';

export function shouldFlashTokens(): boolean {
  return safeLocalStorageGet(FLASH_TOKENS_STORAGE_KEY) === 'true';
}

function replaceTargetTokensWithCssVar(colorObj: any): any {
  const result: any = {};

  for (const [key, value] of Object.entries(colorObj)) {
    result[key] = deprecatedColors.includes(key)
      ? `var(${FLASH_CSS_VAR})`
      : value;
  }

  return result;
}

export const mergeThemeWithOverrides = (
  baseTheme: Theme,
  overrides: Partial<Theme>
): Theme => {
  return {
    ...baseTheme,
    color: {
      ...baseTheme?.color,
      ...overrides.color,
    },
    space: {
      ...baseTheme?.space,
      ...overrides.space,
    },
    borderRadius: {
      ...baseTheme?.borderRadius,
      ...overrides.borderRadius,
    },
    borderWidth: {
      ...baseTheme?.borderWidth,
      ...overrides.borderWidth,
    },
    boxShadow: {
      ...baseTheme?.boxShadow,
      ...overrides.boxShadow,
    },
    typography: {
      ...baseTheme?.typography,
      ...overrides.typography,
    },
  };
};

export function applyThemeOverrides(
  theme: Theme,
  themeOverrides?: Partial<Theme>
) {
  if (themeOverrides && Object.keys(themeOverrides).length > 0) {
    theme = mergeThemeWithOverrides(theme, themeOverrides);
  }

  if (getUseCssVariables()) {
    theme = getCssVariablesTheme(theme);
  }

  // Apply flashing if enabled
  if (shouldFlashTokens()) {
    theme = {
      ...theme,
      color: replaceTargetTokensWithCssVar(theme.color),
    };
  }

  return theme;
}
